<template>
    <div v-loading="loading" class="page-table listPage mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            {{$t("src.views.apps.rakamlar.islem.baslikH1")}}
        </div>
        <div>
            <el-row :gutter="10">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs v-if="$store.state.dilDurum" class="hidden-md-and-down language" tab-position="left"
                             v-model="dil" @tab-click="dilChange">
                        <el-tab-pane label="tr" name="tr">
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft"></div>
                        </el-tab-pane>
                        <el-tab-pane label="en" name="en">
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft"></div>
                        </el-tab-pane>
                    </el-tabs>
                    <el-radio-group v-if="$store.state.dilDurum" class="hidden-md-and-up" v-model="dil" size="mini"
                                    v-on:change="dilChange($event)">
                        <el-radio-button label="tr"><i class="flag-icon flag-icon-tr"></i></el-radio-button>
                        <el-radio-button label="en"><i class="flag-icon flag-icon-gb"></i></el-radio-button>
                    </el-radio-group>
                    <div class="page-header card-base card-shadow--medium animated fadeInUp">
                        <el-table
                                :data="rakamlarListe"
                                style="width: 100%">
                            <el-table-column
                                    prop="rakamAdi"
                                    label="Başlık"
                                    width="auto">
                            </el-table-column>
                            <el-table-column
                                    prop="sayi"
                                    label="Sayı"
                                    width="auto">
                            </el-table-column>
                            <el-table-column
                                    label="İcon"
                                    width="auto">
                                <template slot-scope="scope">
                                    <el-tooltip :content='scope.row.icon' :open-delay="500" placement="right">
                                        <i style="color: #0075c3; font-size: 20px" :class='scope.row.icon'></i>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="İşlem"
                                    align="right"
                                    width="auto">
                                <template slot-scope="scope">
                                    <el-tooltip :content='$t("src.views.apps.rakamlar.islem.duzenle")' :open-delay="500"
                                                placement="bottom">
                                        <el-button
                                                v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                                type="text"
                                                class="buttonEdit"
                                                icon="el-icon-edit">
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip :content='$t("src.views.apps.rakamlar.islem.sil")' :open-delay="500"
                                                placement="bottom">
                                        <el-button
                                                v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                                type="text"
                                                class="buttonDel"
                                                icon="mdi mdi-delete mdi-24px">
                                        </el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                                background
                                layout="sizes,prev, pager, next, jumper, total"
                                :total="total"
                                @size-change="handleSizeChange"
                                @current-change="pageChange"
                                :page-sizes="[10, 20, 50, 100]"
                                :current-page.sync="page"
                                :next-click.sync="page"
                                :prev-click.sync="page"
                                @next-click="pageChange"
                                @prev-click="pageChange">
                        </el-pagination>
                    </div>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                        <el-form status-icon :model="rakamForm" :rules="rulesRakam" ref="rakamForm"
                                 class="demo-ruleForm">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.rakamlar.islem.rakamAdi")'
                                                  prop="rakamAdi">:
                                        <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                  v-model="rakamForm.rakamAdi"
                                                  :placeholder='$t("src.views.apps.rakamlar.islem.rakamAdiPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="$store.state.dilDurum" :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.rakamlar.islem.rakamAdiEN")'
                                                  prop="rakamAdiEN">:
                                        <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                  v-model="rakamForm.rakamAdiEN"
                                                  :placeholder='$t("src.views.apps.rakamlar.islem.rakamAdiPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.rakamlar.islem.sayi")' prop="sayi">:
                                        <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                  v-model="rakamForm.sayi" v-mask="'######'"
                                                  :placeholder='$t("src.views.apps.rakamlar.islem.sayiPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item>
                                        <el-button size="small" type="success" v-on:click="iconListDialog = true"
                                                   icon="el-icon-search">İcon Seç
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" class="col-p">
                                    <el-form-item>
                                        <el-button v-if="btnVisible" size="small" v-on:click="rakamTanimla('rakamForm')"
                                                   type="primary">
                                            {{$t('src.views.apps.rakamlar.islem.ekle')}}
                                        </el-button>
                                        <el-button v-else size="small" v-on:click="guncelleme('rakamForm')"
                                                   type="primary">
                                            {{$t('src.views.apps.rakamlar.islem.guncelle')}}
                                        </el-button>
                                        <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('rakamForm')">
                                            {{$t('src.views.apps.rakamlar.islem.vazgec')}}
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                        </el-form>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog
                :title='$t("src.views.apps.rakamlar.islem.iconList")'
                :visible.sync="iconListDialog"
                width="60%"
                center>
            <div>
                <el-row class="iconRow">
                    <el-col v-for="(item,index) in iconListe"
                            :key="item"
                            :label="item"
                            :value="item" :lg="4" :md="4" :sm="8" :xs="8"
                            style="border: 1px solid #9a9a9a; padding: 5px; height: 100px; text-align: center;display:table">
                        <div v-on:click="iconSelect(item)" class="iconCerceve" id="#iconCerceve">
                            <el-button type="text" v-on:click="iconDoubleClick(item)">
                                <i style="font-size: 24px;text-align: center" :class="item"></i>
                            </el-button>
                            <br>
                            <span class="icon-name" :data-class="item">{{item}}</span>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </el-dialog>
        <el-dialog
                :title='$t("src.views.apps.rakamlar.islem.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["rakamAdi"]}}" {{$t('src.views.apps.rakamlar.islem.alertP')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="sil(selection,selectionIndex,rakamlarListe), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>

    import rakamService from '../../../WSProvider/RakamService'
    import notification from '../../../notification'
    import iconJson from '../../../icon'
    import JQuery from 'jquery';

    let $ = JQuery;
    import '@fortawesome/fontawesome-free/css/all.css'
    import '@fortawesome/fontawesome-free/js/all.js'

    let base64 = require('base64_js');
    let userDataEstas = "";
    export default {
        name: "RakamlarIslem",
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataEstas")) {
                userDataEstas = JSON.parse(base64.decode(localStorage.getItem("userDataEstas")));
                if (userDataEstas["tur"]) {
                    if (userDataEstas["tur"] === '1' || userDataEstas["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                this.getRakamlarList();
            }
        },
        data() {
            return {
                loading: false,
                dil: 'tr',
                icon: '',
                iconListe: iconJson["v5.0.9"],
                formBase64: '',
                rakamlarListe: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                iconListDialog: false,

                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,

                rakamForm: {
                    rakamAdi: '',
                    rakamAdiEN: '',
                    sayi: '',
                    icon: '',
                },
                rulesRakam: {
                    rakamAdi: [{
                        required: true,
                        message: "Lütfen Rakam Adı Giriniz",
                        trigger: 'blur'
                    }],
                    sayi: [{
                        required: true,
                        message: "Lütfen Sayı Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getRakamlarList();
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getRakamlarList();
            },
            dilChange(tab) {
                if (tab.label) {
                    this.dil = tab.label;
                } else {
                    this.dil = tab;
                }
                this.getRakamlarList();
            },
            iconSelect(value) {
                this.rakamForm.icon = value;
                this.icon = value;
                $("body").find(".aktifIkon").removeClass("aktifIkon")
                $(".iconRow").find('span[data-class="' + value + '"]').closest(".iconCerceve").parent("div").addClass("aktifIkon");
                notification.Status("success", this, value + " iconu seçildi.")
            },
            iconDoubleClick(value) {
                this.rakamForm.icon = value;
                this.icon = value;
                $("body").find(".aktifIkon").removeClass("aktifIkon")
                $(".iconRow").find('span[data-class="' + value + '"]').closest(".iconCerceve").parent("div").addClass("aktifIkon");
                this.iconListDialog = false;
                notification.Status("success", this, value + " iconu seçildi.")
            },
            getRakamlarList() {
                let self = this;
                rakamService.rakamListesi(this.postPage, this.sizes, this.dil).then((response) => {
                    if (response.status === 200) {
                        self.rakamlarListe = [];
                        response.data.forEach(function (e) {
                            if (e.durum === '1') {
                                self.rakamlarListe.push(e);
                            }
                        })
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                rakamService.rakamDetay(scope.rakamKodu).then((response) => {
                    if (response.status === 200) {
                        this.rakamForm.rakamAdi = response.data.rakamAdi;
                        this.rakamForm.sayi = response.data.sayi;
                        this.rakamForm.icon = response.data.icon;
                        if (this.$store.state.dilDurum) {
                            this.rakamForm.rakamAdiEN = response.data.dil.en;
                        }
                        this.updateKodu = response.data.rakamKodu;
                        this.btnVisible = false;
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            guncelleme(formName) {
                let dil = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.$store.state.dilDurum) {
                            dil = {
                                en: this.rakamForm.rakamAdiEN,
                            }
                        }
                        rakamService.rakamGuncelle(this.updateKodu, this.rakamForm.rakamAdi, this.rakamForm.sayi, this.rakamForm.icon, dil).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Program başarıyla güncellendi...');
                                this.rakamlarListe.splice(this.selectionIndex, 1);
                                this.rakamlarListe.splice(this.selectionIndex, 0, {
                                    rakamAdi: response.data.rakamAdi,
                                    rakamAdiEN: response.data.rakamAdiEN,
                                    sayi: response.data.sayi,
                                    icon: response.data.icon,
                                    rakamKodu: response.data.rakamKodu
                                });
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir rakam zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });

                    }
                })
            },
            sil(selection, index, list) {
                rakamService.rakamArsiv(selection.rakamKodu).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Rakam başarıyla silindi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            rakamTanimla(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.$store.state.dilDurum) {
                            var dil = {
                                tr: this.rakamForm.rakamAdi,
                                en: this.rakamForm.rakamAdiEN,
                            };
                        }else{
                            dil = {
                                tr: this.rakamForm.rakamAdi,
                            };
                        }
                        rakamService.rakamlarTanimlama(dil, this.rakamForm.sayi, this.rakamForm.icon).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Rakam başarıyla eklendi.');
                                this.rakamlarListe.push(response.data);
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir rakam zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .iconCerceve {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .blue {
        border: 1px solid #0075c3;
    }

    .aktifIkon {
        background: #77ccbe80;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }
</style>

<style scoped>

</style>